"use client";
// Imports
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import Link from "next/link";
import { Placeholder, Img, AddToMyShowButton } from "@/components";
import { User } from "lucide-react";
import { X } from "lucide-react";
import { Check } from "@phosphor-icons/react";
import { DrawerClose } from "@/components/ui/drawer";

export function ShowbagDetails({
  data,
  userId,
  type,
  title,
  categories,
  items,
  stalls,
  operator,
  locations,
  price,
  value,
  showAddToMyShow,
  image,
  mapIsActive,
}) {
  return (
    <div
      className="grid lg:h-full h-[90dvh] max-h-[90dvh] overflow-y-auto grid-cols-1 lg:overflow-hidden lg:grid-cols-2"
      style={{
        // Red gum accents instead of theme saddle orange
        "--button-background": "137 33 2",
        "--button-hover-background": "137 33 2",
        "--button-foreground": "255 255 255",
      }}
    >
      <div className="order-last col-span-1 w-full h-full rounded-l-lg lg:order-first bg-background text-foreground">
        <div className="flex flex-col justify-between p-4 space-y-6 h-full lg:p-8">
          <div className="pr-2 space-y-5">
            <div className="flex justify-between space-x-5 w-full">
              <h2 className="level-2">{title}</h2>
              <div className="flex items-start">
                {showAddToMyShow && (
                  <AddToMyShowButton
                    userId={userId}
                    type={type}
                    slug={data.slug}
                    image={image}
                    title={title}
                  />
                )}
              </div>
            </div>

            {categories?.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {categories?.map((category, index) => (
                  <Label
                    dark={false}
                    key={index}
                    className="bg-brand-red-gum text-white"
                  >
                    {category?.title}
                  </Label>
                ))}
              </div>
            )}
          </div>
          {items?.length > 0 && (
            <div className="flex overflow-auto flex-col justify-start h-full max-h-80">
              <p className="font-bold">Inside the bag:</p>
              <ul className="my-2 space-y-1">
                {items?.map((item, index) => (
                  <li key={index} className="flex space-x-3 leading-tight">
                    <div>
                      <Check weight="bold" size={20} />
                    </div>
                    <span>{item?.item_title}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {stalls?.length > 0 && (
            <div>
              <p className="pb-2 font-bold">Located at:</p>
              <div className="flex flex-wrap gap-2 justify-start items-center w-full">
                {stalls &&
                  stalls?.map((stall, index) => (
                    <span
                      key={index}
                      className="rounded-full border-2 border-brand-red-gum bg-brand-red-gum px-2 font-bold text-white"
                    >
                      {stall?.title}
                    </span>
                  ))}
              </div>
            </div>
          )}
          {locations?.length > 0 && mapIsActive && (
            <div className="space-y-3">
              <div className="">
                <p className="pb-2">Where to find</p>
                <div className="flex overflow-y-hidden justify-between items-center w-full">
                  <div className="flex flex-wrap gap-2 justify-start w-full">
                    {locations.map((location, index) => (
                      <Button size="xs" key={index} variant="outline">
                        <Link href={`/map?pin=${location?.slug}`}>
                          {location?.title}
                        </Link>
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="relative col-span-1 flex h-full w-full items-start justify-center bg-brand-wool py-8 lg:py-0">
        <div className="absolute bottom-4 left-4 z-50 flex space-x-3 rounded-xl bg-brand-red-gum p-4 text-white shadow-lg lg:bottom-8 lg:left-8">
          <div className="flex justify-end items-center">
            <div className="text-center">
              <h3 className="leading-none level-1">{price}</h3>
              <p className="font-bold leading-none level-4 text-white">
                {value}
              </p>
            </div>
          </div>
        </div>
        <div className="flex h-60 items-start justify-center overflow-hidden rounded-t-lg bg-brand-wool lg:h-auto lg:p-8 lg:rounded-none">
          <DrawerClose asChild>
            <div className="absolute right-2 top-2 z-50 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-brand-red-gum text-white lg:hidden">
              <X />
            </div>
          </DrawerClose>
          <div className="flex w-60 items-start justify-center overflow-hidden rounded-base bg-brand-wool lg:w-96">
            {image?.permalink ? (
              <Img
                className="h-auto"
                data={image}
                sizes="(max-width: 1024px) 100vw, 500px"
              />
            ) : (
              <Placeholder type="image-placeholder" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
